"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ElevatingYourKansasCityInvestments() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="122825" id="professional-property-management-services-in-kansas-city" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden !bg-[url(https://investkcpm.com/wp-content/uploads/2026/03/kc_duplex_hero.webp)]">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1584719/img/kc_duplex_hero.png')] bg-cover bg-center bg-no-repeat" />
        <div className="absolute inset-0 bg-primary/80 backdrop-blur-[1px]" />
      </div>

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
        <div ref={ref} className={`max-w-3xl flex flex-col items-start text-left transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h1 className="leading-[1.05] text-white mb-6 tracking-tighter !font-default !text-5xl !font-bold">
            Professional Property Management Services in Kansas City
          </h1>
          
          <p className="font-sans font-normal text-lg mb-10 max-w-2xl leading-relaxed !text-[rgba(234,228,216,1)] sm:text-xl">Invest KC is a boutique residential and commercial property management company dedicated to optimizing your real estate investments. We manage homes, duplexes, multifamily properties, and select office and retail assets throughout the Kansas City metro with precision and care—backed by deep local expertise, transparent processes, and dependable communication.</p>
          
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <Button size="lg" className="h-14 px-8 text-base font-bold rounded-sm shadow-xl shadow-black/20 bg-primary text-primary-foreground hover:bg-secondary hover:text-secondary-foreground transition-colors duration-300" asChild>
              <Link to="/ServicesPage">Owner Services</Link>
            </Button>
            
            <Button size="lg" variant="outline" className="h-14 px-8 text-base font-bold rounded-sm bg-white/10 border-white/30 text-white hover:bg-white/20 hover:text-white backdrop-blur-md transition-all duration-300" asChild>
              <Link to="/AvailablePage">Tenant Service</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 animate-bounce">
        <span className="font-mono text-[10px] font-bold tracking-[0.2em] text-white/60 uppercase">Scroll</span>
        <ArrowDown className="w-5 h-5 text-secondary" />
      </div>
    </section>;
}